<template>
  <b-modal
    id="custom-modal"
    title="Consulta de Materiais"
    :visible.sync="visible"
    @hide="handleClose"
    size="xl"
    class="custom-modal"
    hide-footer
  >
    <b-col cols="12" class="mb-3">
      <label for="input-busca">Pesquisa no grid</label> 
      <b-form-input
        id="buscamonitoramento"
        v-model="search"
        required="required"
        placeholder="Pesquisar por Descrição ou Código do material"
      ></b-form-input>
    </b-col>        

    <!-- Conteúdo do Modal -->
    <b-table :items="itemsFiltered" :fields="fields" hover striped sticky-header="660px" class="custom-table">
      <template #cell(name)="data">
        <b>{{ data.value }}</b>
      </template>

      <template #cell(valor_venda)="data">
        {{ formatCurrency2(data.item.valor_venda) }}
      </template>
    </b-table>

    <!-- Custom Footer with OK Button -->
    <template modal-footer>
      <b-button variant="primary" block @click="loadProdutos()">
        Carregar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { baseApiUrl } from "@/global";
import axios from "axios";
import { mapState } from 'vuex';
import NumericInput from '../utilitarios/NumericInput';

export default {
  name: "ConsultaMaterial",
  
  props: ["visible"],
  data() {
    return {
      produtos: [],
      search: '', // Adicione a propriedade search
      fields: [
        { key: "codigo_erp", label: "Código Material", sortable: true  },
        { key: "descricao", label: "Descrição", sortable: true  },
        { key: "cor", label: "Cor" , sortable: true },
        { key: "tamanho", label: "Tamanho" , sortable: true },
        { key: "valor_venda", label: "R$ valor venda" , sortable: true },          
      ],
    };
  },

  computed: {
    ...mapState(['user']),

    itemsFiltered() {
      const search = this.search.toLowerCase(); // Converta a pesquisa para minúsculas
      return this.produtos.filter(item => {
        const codigo_erp = (item.codigo_erp || '').toLowerCase();
        const descricao = (item.descricao || '').toLowerCase();
        return codigo_erp.includes(search) || descricao.includes(search);
      });
    },
  },

  components: {
    NumericInput
  },

  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },

    async loadProdutos() {
      try {
        const corpo = {
          empresa_id: `${this.user.id_empresa}`,
          filtro: "COMPLETO",
        };
        const url = `${baseApiUrl}/sambaiba/cf7/produto`;
        const res = await axios.post(url, corpo);
        this.produtos = res.data;
      } catch (error) {
        console.error("Erro ao carregar produtos:", error);
      }
    },

    formatCurrency2(amount) {
      const number = parseFloat(amount);
      if (isNaN(number)) {
        return 'R$ 0,00'; // Valor padrão se não for um número
      }
      return number.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
  },
  
  mounted() {
    this.loadProdutos();
  },
};
</script>

<style scoped>
/* Ensure the modal is centered both vertically and horizontally */
.custom-modal .modal-dialog {
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  margin: auto;
}

.custom-modal .modal-content {
  width: 90vw; /* Adjust width as needed */
  max-width: 800px; /* Maximum width for the modal */
  height: 80vh; /* Adjust height as needed */
  max-height: 600px; /* Maximum height for the modal */
  overflow-y: auto; /* Add scrollbar if content is too large */
}

/* Increase font size for table headers and cells */
.custom-table th, 
.custom-table td {
  font-size: 4px!important; /* Adjust font size as needed */
}